/* eslint-disable import/prefer-default-export */

import { SelectOptionType } from "src/types/selectOption";
import { REGION, REGION_OPTION } from "../constants/region";

/**
 * convert number to THB  e.g. 100  => ฿100, 1000 => ฿1,000
 * @param number input number;
 * @returns   string of THB;
 */
export const numberToThCurrency = (number: number) =>
  new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);

/**
 * convert number to Rp  e.g. 100  => Rp100, 1000 => Rp1.000, 100.23 => Rp100,23
 * @param number input number;
 * @returns   string of Rp;
 */
export const numberToIdCurrency = (number: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
    .format(number)
    .replace("Rp ", "Rp");

/**
 * convert number to th currency without currency symbo e.g. 1,000,000.
 * @param number input number.
 * @param minimumIntegerDigits min number of display number unit.
 * @returns string of th currency.
 */
export const numberToThCurrencyWithoutSymbol = (
  number: number,
  minimumIntegerDigits?: number
) =>
  new Intl.NumberFormat("en-EN", {
    style: "decimal",
    minimumIntegerDigits,
    minimumFractionDigits: 0,
  }).format(number);

/**
 * convert number to currency base on region
 * @param number input number;
 * @returns   string of currency;
 */
export const numberToCurrency = (number: number) => {
  switch (REGION) {
    case REGION_OPTION.TH:
      return numberToThCurrency(number);
    case REGION_OPTION.ID:
      return numberToIdCurrency(number);
    default:
      return number.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
  }
};

export const formatCurrencyLabelInArray = (items: SelectOptionType[]) =>
  items?.map((item) => ({
    ...item,
    label: numberToCurrency(parseInt(item.value as string, 10)),
  }));

// export const roundDownToDecimalPlaces = (number, decimalPlaces = 2) => {
//   const factor = Math.pow(10, decimalPlaces);
//   return Math.floor(number * factor) / factor;
// };

export const formatCurrencyDecimal = (number: any) => {
  return parseFloat(number);
};
